export const CUSTOM_RESPONSE = {
  VIRTUAL_TOUR_INTERIOR: 'virtual_tour_interior',
  VIRTUAL_TOUR_EXTERIOR: 'virtual_tour_exterior',
  BLUEPRINT_SOUND_SYSTEM: 'blueprint_sound-system',
  BLUEPRINT_SAFETY: 'blueprint_safety',
  CAROUSEL: 'carousel',
  SMART_TABLE: 'smart_table',
  CAROUSEL_NAV: 'carousel_nav',
  CAROUSEL_GALLERY: 'carousel_gallery',
  CAROUSEL_GALLERY_ASSET: 'carousel_gallery_assets',
}
